import { useState } from 'react';
import ModalShell from './ModalShell';
import { useTranslation } from '../../hooks/useTranslation';

const ProfileModal = ({ user, saving, onClose, onSave }) => {
  const { t } = useTranslation();
  const [profileData, setProfileData] = useState({
    full_name: user.full_name || '',
    phone_number: user.phone_number || '',
    address: user.address || '',
    email: user.email || '',
    telegram_chat_id: user.telegram_chat_id || '',
    telegram_id: user.telegram_id || '',
    telegram_name: user.telegram_name || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prev) => ({ ...prev, [name]: value }));
  };

  const fields = [
    { name: 'full_name', label: t('users.fullNameLabel') },
    { name: 'email', label: t('users.emailLabel'), type: 'email' },
    { name: 'phone_number', label: t('users.phoneLabel') },
    { name: 'telegram_chat_id', label: t('users.telegramChatIdLabel') },
    { name: 'telegram_id', label: t('users.telegramIdLabel') },
    { name: 'telegram_name', label: t('users.telegramNameLabel') },
  ];

  return (
    <ModalShell
      title={t('users.editProfileTitle', { username: user.username })}
      size="lg"
      onClose={onClose}
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose}>{t('common.cancel')}</button>
          <button className="btn btn-primary" onClick={() => onSave(profileData)} disabled={saving}>
            {saving ? t('common.saving') : t('common.save')}
          </button>
        </>
      }
    >
      <div className="modal-body">
        <div className="row g-3">
          {fields.map(({ name, label, type }) => (
            <div className="col-md-6" key={name}>
              <label className="form-label">{label}</label>
              <input
                type={type || 'text'}
                className="form-control"
                name={name}
                value={profileData[name] || ''}
                onChange={handleChange}
              />
            </div>
          ))}
          <div className="col-12">
            <label className="form-label">{t('users.addressLabel')}</label>
            <input
              type="text"
              className="form-control"
              name="address"
              value={profileData.address || ''}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </ModalShell>
  );
};

export default ProfileModal;
